import { type DependencyList, useLayoutEffect, useRef, useState } from 'react';

export const FADE_MASK_SX = {
    maskImage: 'linear-gradient(to right, black calc(100% - 14px), transparent 100%)',
    WebkitMaskImage: 'linear-gradient(to right, black calc(100% - 14px), transparent 100%)',
} as const;

function useFadeOverflow<T extends HTMLElement = HTMLElement>(deps: DependencyList) {
    const ref = useRef<T>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useLayoutEffect(() => {
        const el = ref.current;
        setIsOverflowing(el ? el.scrollWidth > el.clientWidth : false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return { ref, isOverflowing };
}

export default useFadeOverflow;
